/* VSYCO — premium product buy box enhancer */
(function () {
  'use strict';

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function cleanText(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    qa('.visually-hidden', c).forEach(function (n) { n.remove(); });
    return (c.textContent || '').trim();
  }

  function toNum(t) {
    var d = (t || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var v = parseFloat(d);
    return isNaN(v) ? 0 : v;
  }

  function symbolOf(t) {
    var m = (t || '').match(/[^\d\s.,]+/);
    return m ? m[0] : '';
  }

  function fmt(sym, n) {
    return sym + Math.round(n).toLocaleString('en-IN');
  }

  function svg(paths) {
    return '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
  }

  function boot() {
    var atc = q('add-to-cart-component');
    if (!atc) return;

    var scope = atc.closest('.shopify-section') || document;
    var form = atc.closest('form') || q('form[action*="/cart/add"]', scope);
    var h1 = q('h1', scope);

    /* ---------- 1. breadcrumb ---------- */
    if (h1 && !q('.axb-crumb', scope)) {
      var nav = document.createElement('nav');
      nav.className = 'axb-crumb';
      var home = document.createElement('a');
      home.href = '/';
      home.textContent = 'Home';
      var sep = document.createElement('i');
      sep.textContent = '/';
      var shop = document.createElement('a');
      shop.href = '/collections/all';
      shop.textContent = 'Shop';
      var sep2 = document.createElement('i');
      sep2.textContent = '/';
      var cur = document.createElement('span');
      cur.textContent = (h1.textContent || '').trim();
      nav.appendChild(home); nav.appendChild(sep);
      nav.appendChild(shop); nav.appendChild(sep2);
      nav.appendChild(cur);
      h1.parentNode.insertBefore(nav, h1);
    }

    /* ---------- 2. price row ---------- */
    var priceEl = q('.price', scope);
    var box = priceEl ? priceEl.parentElement : null;
    if (box && !box.hasAttribute('data-axb-price')) {
      box.setAttribute('data-axb-price', '');
      var cmpEl = q('.compare-at-price', box);
      var pTxt = cleanText(priceEl);
      var sym = symbolOf(pTxt) || '₹';
      var price = toNum(pTxt);
      var cmp = cmpEl ? toNum(cleanText(cmpEl)) : 0;

      if (cmp > price && price > 0) {
        var pct = Math.round((1 - price / cmp) * 100);
        if (pct > 0) {
          var badge = document.createElement('span');
          badge.className = 'axb-off';
          badge.textContent = '−' + pct + '%';
          box.appendChild(badge);
        }
        var save = document.createElement('div');
        save.className = 'axb-save';
        save.textContent = 'You save ' + fmt(sym, cmp - price);
        box.appendChild(save);
      }

      var tax = document.createElement('div');
      tax.className = 'axb-tax';
      tax.textContent = 'Inclusive of all taxes · Free shipping across India';
      box.appendChild(tax);
    }

    /* ---------- 3. stock line ---------- */
    var btn = q('button[name="add"]', atc);
    if (btn && h1 && !q('.axb-stock', scope)) {
      var out = btn.hasAttribute('disabled');
      var st = document.createElement('div');
      st.className = 'axb-stock' + (out ? ' out' : '');
      st.innerHTML = '<b></b><span>' + (out
        ? 'Currently out of stock — message us on WhatsApp for restock updates'
        : 'In stock · Dispatched within 24 hours') + '</span>';
      if (form && form.parentNode) form.parentNode.insertBefore(st, form);
    }

    /* ---------- 4. secure checkout note ---------- */
    if (form && !q('.axb-secure', scope)) {
      var sec = document.createElement('div');
      sec.className = 'axb-secure';
      sec.innerHTML = svg('<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>') +
        '<span>100% secure checkout · UPI · Cards · Netbanking · Cash on Delivery</span>';
      form.parentNode.insertBefore(sec, form.nextSibling);
    }

    /* ---------- 5. lift trust / offers / delivery into the buy column ---------- */
    var strip = q('.axd .strip');
    var row = q('.axd .row');
    if (form && (strip || row) && !q('.axd-in')) {
      var wrap = document.createElement('div');
      wrap.className = 'axd axd-in';
      var inner = document.createElement('div');
      inner.className = 'w';
      wrap.appendChild(inner);
      if (strip) inner.appendChild(strip);
      if (row) inner.appendChild(row);
      var anchor = q('.axb-secure', scope) || form;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
